import React, {useState, useEffect} from 'react'
import {Spin} from 'antd'
import Checkbox from 'components/shared/Checkbox'
import Heading from 'components/shared/Heading'
import SelfBooking from './SelfBooking'
import ResourcePreferences from './ResourcePreferences'
import './index.scss'

const unavailabilityMessages = {
  'includes_pick_up_keys': 'Du har valgt nøkkelhenting på dette oppdraget, og foreløpig er ikke dette valget mulig ved selvbooking.',
  'includes_express_delivery': 'Du har valgt levering innen kl 2000 på dette oppdraget, og foreløpig er ikke dette valget mulig ved selvbooking.',
  'includes_evening_photos': 'Du har valgt kveldsfoto på dette oppdraget, og foreløpig er ikke dette valget mulig ved selvbooking.',
  'not_one_attendance': 'Du har valgt leveranser som krever flere oppmøter, foreløpig er ikke dette valget mulig ved selvbooking.',
}

const Booking = (props) => {
  const [useSelfBooking, setUseSelfBooking] = useState(null)
  const {isAvailable, unavailabilityReason} = props.webOrder.selfBookingAvailability
  const unavailabilityMessage = unavailabilityMessages[unavailabilityReason]

  useEffect(() => {
    if (useSelfBooking === null && !props.isFetchingBill) {
      let useSelfBookingValue = false
      const hasResourcePreferences = props.productSelection.preferredPhotographer || props.productSelection.preferredStylist || props.productSelection.preferredResourceDate
      if (props.productSelection.reservedBooking) {
        useSelfBookingValue = true
      }
      if (props.webOrder.selfBookingAvailability.isAvailable && !hasResourcePreferences) {
        useSelfBookingValue = true
      }

      setUseSelfBooking(useSelfBookingValue)
    }
  }, [useSelfBooking, props.isFetchingBill, props.productSelection, props.webOrder])

  return (
    <div className="new-order self-booking">
      <Heading level={2}>Booking</Heading>

      {(() => {
        if (props.isFetchingBill && useSelfBooking === null) {
          return (
            <div className="loading">
              <Spin />
            </div>
          )
        }

        return (
          <>
            {isAvailable && (
              <section className="toggle-self-booking">
                <Heading level={3}>Selvbetjent booking</Heading>
                <Checkbox
                  label="Jeg vil benytte selvbetjent booking"
                  description="Her kan du velge dag, tid og ønsket ressurs for oppdraget. Alternativt kan du legge inn preferanser under og la EFKT ta seg av resten."
                  checked={useSelfBooking}
                  onChange={e => setUseSelfBooking(e.target.checked)}
                />
              </section>
            )}

            {!isAvailable && unavailabilityMessage && (
              <>
                <p className="self-booking-unavailable-notice">
                  <span>Selvbetjent booking er ikke tilgjengelig:</span>
                  {unavailabilityMessage}
                </p>
                <p>Du kan fortsatt spesifisere ønsket ressurs, tidspunkt og prioritet under.</p>
              </>
            )}

            {useSelfBooking && <SelfBooking {...props} />}
            {!useSelfBooking && <ResourcePreferences {...props} />}
          </>
        )
      })()}
    </div>
  )
}

export default Booking
